(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('ModelloSearch', ModelloSearch);

    ModelloSearch.$inject = ['$resource'];

    function ModelloSearch($resource) {
        var resourceUrl =  'api/_search/modellos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
